import DatePicker from 'react-datepicker';
import Collapse from 'react-bootstrap/Collapse';
import useAxios from "../../helpers/useAxios";
import Tabela from './Tabela'
import React, { useState } from "react";
import { pt } from "date-fns/locale";
import { useKeycloak } from "@react-keycloak/web";
import { subtractDaysDate, formatDateStandard, formatStatus, formatSide } from "../../helpers/utils.js";
import 'react-datepicker/dist/react-datepicker.css';
import DetalhePedido from "./DetalhePedido.js";

const GestaoPedidos = () => {
    const { keycloak } = useKeycloak();

    // Filtros
    const [status, setStatus] = useState("0");
    const [order, setOrder] = useState("Desc");
    const [startDate, setSearchStartDate] = useState("");
    const [endDate, setSearchEndDate] = useState("");
    const [nif, setNif] = useState(
        getSessionNif()
    );
    const [isOpen, setIsOpen] = useState(false);

    // Detalhe de um ticket
    const [detail, setDetail] = useState();

    const [successMessage, setSuccessMessage] = useState("");
    const [modalShow, setModalShow] = useState(false);
    const [typingDisabled, setTypingDisabled] = useState(true);

    const columns = [
        { id: 'id', name: "ID" },
        { id: 'dateReg', name: "Data", type: "dateReg" },
        { id: 'subject', name: "Assunto", },
        { id: 'status', name: "Estado", type: "status", },
    ];

    const { fetch, data, error, loaded } = useAxios("POST", "/User/get-user-tickets", {
        Nif: nif,
        Status: parseInt(status),
        Order: order,
        StartCreatedDate: (startDate !== "" && startDate !== null) ? formatDateStandard(startDate, '/') : startDate,
        EndCreatedDate: (endDate !== "" && endDate !== null) ? formatDateStandard(endDate, '/') : endDate
    });

    function getSessionNif() {
        const stored = sessionStorage.getItem('nifAdmin');
    
        try 
        {
          if (stored)
          {
            return JSON.parse(stored);
          }
          else
          {
            return keycloak.tokenParsed.preferred_username;
          }
        }
        catch
        {
          return keycloak.tokenParsed.preferred_username;
        }
      }

    const closeModalShow = () => {
        setModalShow(false);
        setDetail();
    }

    const doDetail = (id) => {
        let result = data.tickets.filter(t => {
            return t.id === id
        })
        setDetail(result[0]);
        if (formatStatus(result[0].status) === 'Em progresso' && formatSide(result[0].side) === 'Cliente') {
            setTypingDisabled(false);
        } else {
            if (formatStatus(result[0].status) === 'Aberto') {
                setTypingDisabled(false);
            } else {
                setTypingDisabled(true);
            }
        }
        setModalShow(true);
    };

    /* MODAL implementation - Start */
    const modalSaveChanges = () => {
        setSuccessMessage("Pedido atualizado com sucesso.");

        window.scrollTo(0, 0);

        setTimeout(function () {
            setSuccessMessage('');
        }, 5000);

        setModalShow(false);
        setDetail();

        fetch("POST", "/User/get-user-tickets", {
            Nif: nif,
            Status: parseInt(status),
            Order: order,
            StartCreatedDate: (startDate !== "" && startDate !== null) ? formatDateStandard(startDate, '/') : startDate,
            EndCreatedDate: (endDate !== "" && endDate !== null) ? formatDateStandard(endDate, '/') : endDate
        });
    }
    /* MODAL implementation - End */

    return (
        <div className="col-md-12 bg-white rounded-4 p-3 mb-4">
            {successMessage.length !== 0 && (
                <div className="alert alert-success alert-layer border-0 d-flex align-items-center mb-5" role="alert">
                    <svg width="16px" height="16px" viewBox="0 0 16 16" className="me-2">
                        <g stroke="none" strokeWidth="1" fill="#FFFFFF" fillRule="evenodd">
                            <path d="M7.48581818,10.5709091 C7.344,10.7127273 7.15781818,10.784 6.97163636,10.784 C6.78545455,10.784 6.59927273,10.7127273 6.45745455,10.5709091 L4.40072727,8.51418182 L5.42909091,7.48581818 L6.97163636,9.02836364 L10.5709091,5.42909091 L11.5992727,6.45745455 L7.48581818,10.5709091 Z M8,0 C3.58909091,0 0,3.58836364 0,8 C0,12.4109091 3.58909091,16 8,16 C12.4109091,16 16,12.4109091 16,8 C16,3.58836364 12.4109091,0 8,0 L8,0 Z" />
                        </g>
                    </svg>
                    <div>
                        {successMessage}
                    </div>
                </div>
            )}
            <div className="row">
                <div className="col-6 my-auto">
                    <h3 className="my-auto">Últimos registos</h3>
                </div>
                <div className="col-6 text-end">
                    <button type="button" className="btn btn-table me-3" onClick={() => setIsOpen(!isOpen)}>
                        <div className="row">
                            <div className="col-4">
                                <svg width="16px" height="16px" viewBox="0 0 1024 1024" className="me-1">
                                    <g stroke="none" strokeWidth="1" fill="#3F5B78" fillRule="evenodd">
                                        <path d="M554.666667 512a42.666667 42.666667 0 0 1 8.533333-25.6l256-341.333333a42.666667 42.666667 0 1 1 68.266667 51.2L640 526.208V768a42.666667 42.666667 0 0 1-23.594667 38.144l-170.666666 85.333333A42.666667 42.666667 0 0 1 384 853.333333v-327.125333L136.533333 196.266667A42.666667 42.666667 0 0 1 170.666667 128h512a42.666667 42.666667 0 0 1 0 85.333333H256l204.8 273.066667a42.666667 42.666667 0 0 1 8.533333 25.6v272.298667l85.333334-42.666667V512z" />
                                    </g>
                                </svg>
                            </div>
                            <div className="col-8 ps-0" style={{ marginTop: '2px' }}>Filtrar</div>
                        </div>
                    </button>
                </div>
            </div>
            <Collapse in={isOpen}>
                <div className="mt-4">
                    <div className="row">
                        <div className="form-group col-3">
                            <label>Data de início</label>
                            <DatePicker className="form-control" selected={startDate} dateFormat="dd/MM/yyyy" locale={pt} showYearDropdown minDate={new Date(2000, 0, 1)} maxDate={endDate !== "" ? endDate : subtractDaysDate(new Date(), 0)} onChange={(date) => {
                                setSearchStartDate(date);
                            }} />
                        </div>
                        <div className="form-group col-3">
                            <label>Data de fim</label>
                            <DatePicker className="form-control" selected={endDate} dateFormat="dd/MM/yyyy" locale={pt} showYearDropdown minDate={startDate !=  "" ? startDate: new Date(2000, 0, 1) } maxDate={subtractDaysDate(new Date(), 0)} onChange={(date) => {
                                setSearchEndDate(date);
                            }} />
                        </div>
                        <div className="form-group col-3">
                            <label>Ordenação</label>
                            <select className="form-control" value={order} onChange={(e) => {
                                setOrder(e.target.value)
                            }}>
                                <option value="Asc">Data ascendente</option>
                                <option value="Desc">Data descendente</option>
                            </select>
                        </div>
                        <div className="form-group col-3">
                            <label>Estado</label>
                            <select className="form-control" value={status} onChange={(e) => {
                                setStatus(e.target.value);
                            }}>
                                {/* <option value="0" disabled>Todos</option> */}
                                <option value="0">Todos</option>
                                <option value="1">Aberto</option>
                                <option value="2">Em progresso</option>
                                <option value="3">Cancelado</option>
                                <option value="4">Fechado</option>
                            </select>
                        </div>
                    </div>
                    <div className="row pt-4">
                        <div className="col-12">
                            <button type="submit" className="btn btn-primary btn-small me-3"
                                onClick={() => {
                                    fetch("POST", "/User/get-user-tickets", {
                                        Nif: nif === "" ? 0 : parseInt(nif),
                                        status: parseInt(status),
                                        order: order,
                                        StartCreatedDate: (startDate !== "" && startDate !== null) ? formatDateStandard(startDate, '/') : startDate,
                                        EndCreatedDate: (endDate !== "" && endDate !== null) ? formatDateStandard(endDate, '/') : endDate
                                    });
                                }}>
                                Mostrar resultados
                            </button>
                            <button type="button" className="btn btn-secondary btn-small"
                                onClick={() => {
                                    setOrder("Desc");
                                    setStatus("0");
                                    setSearchStartDate("");
                                    setSearchEndDate("");
                                }}>
                                Limpar filtro
                            </button>
                        </div>
                    </div>
                </div>
            </Collapse>
            {(loaded && error.length === 0) && (
                <Tabela columns={columns} rows={data.tickets} viewSize={15} onDetailHandler={doDetail} requestsPage={true} />
            )}
            {(modalShow && detail) && (
                <DetalhePedido
                Detail = {detail}
                CloseModalShow = {closeModalShow}
                TypingDisabled={typingDisabled}
                AskForAgreement={detail.status === 4 && detail.agreed === 2}
                SaveChanges={modalSaveChanges} />
            )}

        </div>
    );
};

export default GestaoPedidos;